import { render, staticRenderFns } from "./navigation-drawer.vue?vue&type=template&id=2feae7cf&scoped=true"
import script from "./navigation-drawer.vue?vue&type=script&lang=js"
export * from "./navigation-drawer.vue?vue&type=script&lang=js"
import style0 from "./navigation-drawer.vue?vue&type=style&index=0&id=2feae7cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feae7cf",
  null
  
)

export default component.exports